import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TicketActionAttachmentTypes, StateTypes, UserTypes } from '../../../../common/enums';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { TICKET_MODULE_NAMESPACE, TICKET_LOADERS } from '../../../../store/ticket';

class TicketAction {
  index: number;
  type: string;
  key: string;
  secondaryKey?: string;
  icon: string;
  translationKey?: string;
  actionName?: string;
  buttonName?: string
}

const UserStore = namespace(USER_MODULE_NAMESPACE)
const TicketStore= namespace(TICKET_MODULE_NAMESPACE)

// @ts-ignore
@Component({
  components: {
    'chat-editor-loader': async () => import('../../loaders/ticket-chat-editor-loader/TicketChatEditorLoader.vue')
  }
})
class TicketChatEditor extends Vue {

  public static TICKET_EDITOR_ACTION_ASKAPPOINTMENT = 'AskAppointment';
  public static TICKET_EDITOR_ACTION_CREATEAPPOINTMENT = 'CreateAppointment';
  public static TICKET_EDITOR_ACTION_ASKQUOTE = 'AskQuote';
  public static TICKET_EDITOR_ACTION_ANNOTATION = 'Annotation';
  public static TICKET_EDITOR_ACTION_ATTACHFILE = 'AttachFile';
  public static TICKET_EDITOR_ACTION_ATTACHDOCUMENT = 'AttachDocument';
  public static TICKET_EDITOR_ACTION_MANDATEASPEAKER = 'MandateASpeaker';
  public static TICKET_EDITOR_ACTION_CLOSE = 'Close';
  public static TICKET_EDITOR_ACTION_GENERATE_REPORT = 'GenerateInterventionReport';
  public static TICKET_DELETE_MSG = 'DeleteMsg';
  private _clearTimeout: any;

  dtMenuIsOpened: boolean;
  dtMessage: string | null;
  dtNotificationVisible: boolean;
  dtDocumentConfigs: any;
  dtFileError: boolean
  dtError: any
  /**
   *
   */
  get lblSetting() {
    return { ...require('../../../../locales/ticket').default };
  }
  constructor() {
    super();
    this.dtMenuIsOpened = false;
    this.dtNotificationVisible = false;
    this.dtMessage = '';
    this.dtFileError = false;
    this.dtError = null
    this.dtDocumentConfigs = require('../../../../configs/ticket-document-maxsize.config.json');
  }
  @Prop({ type: [String], required: true })
  ticketState: string;
  @Prop({ default: () => { }, type: [Object] })
  requestModal: { visible: boolean, modalType: string | null };
  @Prop({ default: '', type: [String] })
  value: string;
  @Prop({ default: false, type: [Boolean] })
  hasContructor: boolean;
  @Prop({ type: Function, required: false })
  sendFile: Function;

  @UserStore.Getter userInfo: { type: string }
  @UserStore.Getter canAskAppointment: boolean;
  @TicketStore.Getter loaders: Map<string,boolean>


  get dtActions(): TicketAction[] {
    const modules = this.$store.state.user.userInfo.modules
    function hasDocModule(){
      return modules.includes('document_management')
    }
    const result = [{
      index: 1, type: this.$route.meta.ask_appointment_private ? 'AskAppointment' : 'CreateAppointment',
      icon: 'book',
      key: 'add_appointment',
      secondaryKey: 'ask_appointment_private',
      translationKey: this.lblSetting.ticketChatActionsAddAppointment[this.userInfo.type],
      isAllowed:true,
    },
    {
      index: 2, type: 'AskQuote', icon: 'icon-quote', key: 'ask_quote',
      actionName: 'actionRequestMandateOrQuote',
      translationKey: this.lblSetting.ticketChatActionsAskQuote,
      isAllowed:true,
    },
    /* {
      index: 3, type: 'Annotation', icon: 'gesture', key: 'attach_file',
      translationKey: this.lblSetting.ticketChatActionsAnnotation,
      isAllowed:true,
    },*/
    {
      index: 4, type: 'AttachFile', icon: 'insert_photo', key: 'attach_file',
      translationKey: this.lblSetting.ticketChatActionsAttachFile,
      isAllowed: !hasDocModule(),
    }, 
    {
      index: 5, type: 'AttachDocument', icon: 'icon-add-file', key: 'attach_document',
      translationKey: this.lblSetting.ticketChatActionsAttachFile,
      actionName: 'sendFile',
      isAllowed: hasDocModule(),
    },
    {
      index: 6, type: 'MandateASpeaker', icon: 'icon-flag', key: 'mandate',
      actionName: 'actionRequestMandateOrQuote',
      translationKey: this.lblSetting.ticketChatActionsMandateASpecker,
      isAllowed:true,
    },
    {
      index: 7, type: TicketChatEditor.TICKET_EDITOR_ACTION_GENERATE_REPORT,
      icon: 'assignment_turned_in',
      key: 'intervention_report',/**Disabled util have new task to implement intervention report */
      translationKey: this.lblSetting.ticketChatActionsGenerateInterventionReport,
      actionName: 'actionGenerateInterventionReport',
      isAllowed:true,
    },
    {
      index: 8, type: 'Close', icon: 'icon-cross-bold', key: 'close_ticket',
      translationKey: this.lblSetting.ticketChatActionsClose,
      actionName: 'actionCloseTicket',
      isAllowed:true,
    }]

    return result;
  }
  get coRequestModal() {
    return this.requestModal;
  }
  set coRequestModal(requestModal: any) {
    this.$emit('update:requestModal', requestModal);
  }
  get plusButtonVisible(): boolean {
    return this.ticketState === StateTypes.Close
  }
  get sendMessageButtonVisible(): boolean {
    return this.dtMessage.length <= 0;
  }
  get coLoader(): boolean {
    return this.loaders.get(TICKET_LOADERS.CHAT_EDITOR)
  }
  handleMenuClick(btn: any) {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {

      if (btn.type === 'AttachFile') {
        (this.$refs['fileRef'] as any).click();
      }
      else {
        this.coRequestModal = { visible: true, ...btn };
      }
    }, 300);
  }



  checkVisible(key: string, secondaryKey: string) {
    return this.$route.meta[key] || this.$route.meta[secondaryKey];
  }


  disabled(key: string, secondaryKey: string) {
    if (key === 'close_ticket')
      return this.ticketState === StateTypes.Close && this.$route.meta[key].close_ticket;
    return (!this.$route.meta[key] && !this.$route.meta[secondaryKey]);
  }
  private calculateMaxSize(type: string): number {
    return this.dtDocumentConfigs[type].alpha * this.dtDocumentConfigs.minimum
  }
  async handleUploadButton({ files }, type: "image") {

    for (let fIndex = 0; fIndex < files.length; fIndex++) {
      const file = files[fIndex];
      const formData = new FormData();
      formData.append('file', file);
      const reader = new FileReader();
      await reader.readAsDataURL(file)
      reader.onload = async () => {
        const fileTransfer: {
          type?: string,
          file: any,
          name: string,
          percentage?: number
          fakeId: string, loader_id: string
        } = {
          file: reader.result,
          name: file.name, percentage: 0,
          fakeId: `${new Date().getTime()}-${file.size}`,
          loader_id: `${new Date().getTime()}-${file.size}`,
        };
        if (file.type.indexOf(TicketActionAttachmentTypes.AttachmentImage) > -1) {
          fileTransfer.type = TicketActionAttachmentTypes.AttachmentImage;
        } else if (file.type.indexOf(TicketActionAttachmentTypes.AttachmentVideo) > -1) {
          fileTransfer.type = TicketActionAttachmentTypes.AttachmentVideo;
        }
        else {
          fileTransfer.type = TicketActionAttachmentTypes.AttachmentDocument;
        }
        this.$emit('send-file', fileTransfer);
        this.$refs.fileRef['value'] = null;
      }
    }

  }


  handleBreakLine() {
    this.dtMessage += '\n';
  }

  handleSendMessage(event: any) {
    event.preventDefault();
    if (!this.$route.meta.send_message) {
      return;
    }

    if (this.dtMessage.trim().length === 0)
      return;
    if (this.$route.meta.reopen_ticket && this.ticketState === StateTypes.Close) {
      this.dtNotificationVisible = true;

      return;
    }

    this._handleSendMessage();
  }
  private _handleSendMessage() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      const message = this.dtMessage;
      this.dtMessage = '';
      this.$emit('send', message);
    }, 0);
  }
  handleConfirm() {
    this.dtNotificationVisible = false;
    this._handleSendMessage();
  }
  checkActionVisible(index: number) {
    return index < document.getElementsByClassName('.sub-action-pointer').length - 1;
  }
  handleHideError() {
    this.dtFileError = false;
    this.dtError = null;
  }
}

export default TicketChatEditor;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-editor/index.ts